<template>
  <v-form ref="form" class="">

    <BaseUtil
      ref="util"
      :pageLoading="pageLoading"
    />

    <v-tabs :show-arrows="false">
      <v-tab>Informações</v-tab>
      <v-tab v-if="entry.id">Itens Armazenados</v-tab>
      <!-- <v-tab>Armazenagem Inicial</v-tab> -->

      <v-tab-item>
        <v-row>
          <v-col cols="12">
            <v-text-field
              v-model="entry.name"
              v-bind="getObject('name')"
              label="Nome"
              autocomplete="off"
              :disabled="readOnly"
            />
          </v-col>

          <v-col cols="12" sm="8">
            <v-text-field
              v-model="entry.location"
              v-bind="getObject('location')"
              label="Localização"
              autocomplete="off"
              :disabled="readOnly"
            />
          </v-col>

          <v-col cols="12" sm="6" md="4">
            <MaskedTextField
              v-bind="getObject('capacity')"
              :inputData.sync="entry.capacity"
              mask-type="currency"
              label="Capacidade"
              suffix="Kg"
              autocomplete="off"
              :disabled="readOnly"
            />
          </v-col>
        </v-row>
      </v-tab-item>

      <!-- itens em estoque -->
      <v-tab-item v-if="entry.id ? true : false">
        <v-row>
          <v-col cols="12" class="">
            <StorageItemIndex
              :storageItems="entry.storageItems"
              :readOnly="true"
              :storageItemsTotalPrice.sync="storageItemsTotalPrice"
              objectType="StorageItem"
              key="storage_items"
              modelNameSingular="Item em Estoque"
              modelNamePlural="Itens em Estoque"
              :enabledLots="entry.enabledLots"
              :hasLots="entry.hasLots"
              :showExpanded="false"
            />            
          </v-col>
        </v-row>
      </v-tab-item>
            
    </v-tabs>
  </v-form>
</template>

<script>
import MaskedTextField from "@shared_components/masked_text_field.vue"
// import PurchaseItemIndex from "@models/purchase_items/index.vue"
import StorageItemIndex from "@models/storages/storage_items/index.vue"
import BaseUtil from "@shared_components/base_util.vue";

export default {
  data() {
    return {
      entryAttributes: {},
      // initialPurchaseItemsTotalPrice: 0,
      storageItemsTotalPrice: 0,
      pageLoading: false,
    };
  },
  props: {
    entry: Object,
    extraData: Object,
    readOnly: {
      type: Boolean,
      default: false
    },
    enabledLots: {
      type: Boolean,
      default: false,
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    modelNameSingular: String,
  },
  components: {
    MaskedTextField: MaskedTextField,
    BaseUtil: BaseUtil,
    StorageItemIndex: StorageItemIndex,
    // PurchaseItemIndex: PurchaseItemIndex
  },
  beforeCreate: function () {
    // this.$options.components.PurchaseItemIndex = require('@models/purchase_items/index.vue').default
  },
  created() {
    this.entryAttributes = this.setupEntryAttributes(this.entry);

    // console.log("entry", this.entry);

    // calcula o totalizador dos itens de estoque inicial
    // this.initialPurchaseItemsTotalPrice = 0;
    // for (var product in this.entry.purchaseItemsAttributes) {
    //   if (this.entry.purchaseItemsAttributes[product] && this.entry.purchaseItemsAttributes[product].totalPrice && !this.entry.purchaseItemsAttributes[product]._destroy) {
    //     this.initialPurchaseItemsTotalPrice += this.entry.purchaseItemsAttributes[product].totalPrice;
    //   }
    // }
    // this.initialPurchaseItemsTotalPrice = _.round(this.initialPurchaseItemsTotalPrice, 2);


    // calcula o totalizados dos itens de estoque
    this.storageItemsTotalPrice = 0;
    for (var product in this.entry.storageItems) {
      if (this.entry.storageItems[product] && this.entry.storageItems[product].availableTotalPrice && !this.entry.storageItems[product]._destroy) {
        this.storageItemsTotalPrice += this.entry.storageItems[product].availableTotalPrice;
      }
    }
    this.storageItemsTotalPrice = _.round(this.storageItemsTotalPrice, 2);
  },
  mounted() {
  },
  methods: {
    getObject: function(element, component) {
      return this.entryAttributes[element];
    },
    isFormValid: function() {
      if (this.$refs.form.validate()) {
        return true;
      } else {
        setTimeout(function(){
          document.querySelector(".v-messages.error--text:first-of-type").scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 500);
      }
      return false;
    },
    resetFormInputs: function() {
      this.$refs.form.resetValidation();
    },
  }
};
</script>

<style scoped></style>
